<template>
  <div class="shadow">
      <div  style="height: 100vh; width: 100%">
        <l-map :zoom="zoom" :center="center">
          <!-- <l-marker
              v-for="(marker, index) in markers"
              :key="index"
              ref="markersRef"
              :lat-lng="marker.position"
            >
              <l-popup :content="marker.name"/>
            </l-marker> -->
          <l-marker
              v-for="(marker, index) in AllApplication"
              :key="index"
              
              :lat-lng="latLng(marker.latitude, marker.longitude)"
            >
                <l-icon 
              :icon-size="iconSize"
              :icon-url ="icon"> 
                
              </l-icon>
              <l-popup :content="marker.appname"/>
            </l-marker> 
         <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
          <l-control-scale position="topright" :imperial="false" :metric="true"></l-control-scale>
            </l-map>
      </div>
  </div>
</template>

<script>
// export default {
// import { Icon } from 'leaflet';  

import L from 'leaflet';
import markerIcon from '../../assets/img/marker2.png' 

import {LMap, LIcon, LTileLayer, LControlScale, LMarker, LPopup} from 'vue2-leaflet';
// import {LMap, LTileLayer, LControlScale, LMarker} from 'vue2-leaflet';

// see here https://codesandbox.io/s/zrp7o89op3?file=/src/components/MyMap.vue
// http://jsfiddle.net/f7dksf2m/2/
// https://github.com/vue-leaflet/Vue2Leaflet#how-can-i-bind-events-of-vue2leaflet-components-
// https://stackoverflow.com/questions/58240998/how-to-add-vue-router-link-inside-of-leaflet-marker-popup
// https://regenrek.com/posts/how-to-build-a-breakfast-restaurant-locator-with-nuxtjs-and-algolia-search/

export default {
  components: {
    LMap,
    LTileLayer,
    LControlScale,
    LMarker,
    LPopup,
    LIcon
  },
  data () {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 12,
      center: [	0.133333,117.500000],
      attribution:'&copy; Supported by<a href="http:zumiot.id"> ZUMIOT</a> ',
      // markers: [
            
      //       { Id: 1, name: "Sensor 1", position: { lat: 0.1334419, lng: 117.4818381, } },
      //       { Id: 2, name: "Sensor 2", position: { lat: 0.1327805, lng: 117.483593} },
      //       { Id: 3, name: "Sensor 3", position: { lat: 0.1333049, lng: 117.481251} },
   
      //     ],
          markerObjects: null,
          icon:markerIcon,
          iconSize:[30,50]
    
    };
  },
    computed: {
        AllApplication() {
            return this.$store.state.AllApplication
        }
    },


  methods: {

    latLng: function(lat,lng) {
      return L.latLng(lat,lng)
    },

  }



}

</script>